import React from 'react';
import styled from 'styled-components';
import about from '../assets/about.jpg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    .about {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        margin: 60px 0;
        .about_img {
            width: 30vw;
            border-radius: 10px;
        }
        .about__text {
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
    }
`

function AboutMe() {
  return (
      <Wrapper>
          <h2 id='aboutMe'>Sobre mim</h2>
          <div className='about'>
              <img className='about_img' src={about} alt=''/>
              <div className='about__text'>
                  <p>Pode me chamar de Lindy!</p>
                  <p>Sempre fui muito do time qualidade antes de quantidade. Por isso, nas redes sociais que gerencio busco olhar para as pessoas e não somente para números.</p>
                  <p>No entanto, pensar em pessoas não minimiza os resultados. Trabalho de maneira estratégica e humana para alcançar seus objetivos nas redes sociais.</p>
              </div>
          </div>
      </Wrapper>
  );
}

export default AboutMe;